module.exports = __webpack_public_path__ + "c4b92848c212dc4c6ed6222f77d1e854.svg";


//////////////////
// WEBPACK FOOTER
// ../images/icons/svg/icon-youtube-black.svg
// module id = 1004
// module chunks = 69